module.exports = __webpack_public_path__ + "img/accord.08d841a8.svg";